import { Button, Col, Form, Modal, Row, message } from "antd";
import React, { useRef, useState } from "react";
import Webcam from "react-webcam";
import ZenFormInput from "./InputCreater/ZenFormInput";
import ApiErrorComp from "../components/ApiErrorComp/ApiErrorComp";
import { CameraOutlined, DeleteOutlined } from "@ant-design/icons";
import liracrypt from "../components/Liracrypt/liracrypt";

const CameraComponent = () => {
  const webcamRef = useRef(null);
  const [form] = Form.useForm();
  const [openCamera, setOpenCamera] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const [cameraFacingMode, setCameraFacingMode] = useState('user');
  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      let audio = new Audio(require('../assets/audio/camera-click.mp3'));
      audio.play();
      setCapturedImage(imageSrc);
    } else {
      ApiErrorComp();
    };
    setOpenCamera(false);
  };

  const toggleCamera = () => {
    setOpenCamera(!openCamera);
  };

  const checkPrevImg = (val) => {
    setOpenCamera(false);
    setCapturedImage(false);
    liracrypt.get('/imagecontrol', { _id: val })
      .then(({ data }) => {
        if (data.isSuccess) {
          setCapturedImage(data.data);
          Modal.confirm({
            title: 'Image already exists! Do you want to take new one?',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => setOpenCamera(true)
          })
        } else {
          setOpenCamera(true);
        }
      }).catch(err => {
        console.log(err)
        setOpenCamera(true);
      })

  }

  const uploadImageToServer = async () => {
    console.log(capturedImage);
  };

  const onFinish = (values) => {
    setFormLoading(true);
    let formVal = { ...values };
    formVal.image = capturedImage;
    liracrypt.post('/test', formVal)
      .then(({ data }) => {
        if (data.isSuccess) {
          message.success(data.message);
        } else {
          message.error(data.message || 'Something went wrong');
        };
        setFormLoading(false);
      })
      .catch(err => {
        setFormLoading(false);
        console.log(err);
        ApiErrorComp();
      })
  }

  return (
    <div>
      <div
        className="AuditSection CreateAudit"
        style={{
          padding: "10px"
        }}
      >
        <div className="ThemeForm">
          <Form
            labelWrap={true}
            name={"ReportForm"}
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <Row justify={"center"}>
              <ZenFormInput
                // header={data.header}
                // footer={data.footer}
                labelColSpan={8}
                // style={data['style']}
                // height={data['height']}
                layoutPosition="space-between"
                form={form}
                // LocalDict={LocalDict}
                // rows={data.rows}
                colSpan={window.screen.width > 767 ? 12 : 24}
                name={"part"}
                label={"Part"}
                defaultValue={""}
                typ={"dropDown"}
                disabled={false}
                source={"data"}
                sourceParams={{
                  typ: 'EmployeeCurrentPast',
                  subTyp: 'idame'
                }}
                options={{
                  "a": "A",
                  "b": "B",
                  "c": "C"
                }}
                // auxParams={data["auxParams"]}
                // format={data["format"]}
                errorMessage={"Please Select Part"}
                placeHolder={"Select Part"}
                required={true}
                //  options={data["data"]}
                //  from={data["data_index_from"]}
                //  to={data["data_index_to"]}
                //  url={data["url"]}
                includeAll={false}
                onChange={(label, val) => {
                  console.log(val, label);
                  checkPrevImg(val);
                }}
                pname={"part_p"}
                // defaultFrom={data["defaultFrom"]}
                // defaultTo={data["defaultTo"]}
                multiSelect={false}
                searchable={true}
                data={{}}
              // extraData={extraData}
              // children={data['children']}
              />
            </Row>
            {
              openCamera ?
                <Row justify={"center"}>
                  <Col span={window.screen.width > 767 ? 12 : 24}>
                    <Webcam
                      width={window.screen.width > 767 ? undefined : 300}
                      videoConstraints={{
                        facingMode: cameraFacingMode
                      }} mirrored={cameraFacingMode === 'user'} ref={webcamRef} screenshotFormat="image/jpeg" />
                    <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                      <Button style={{ marginRight: 10 }} type="primary" onClick={captureImage}>Capture</Button>
                      <Button type="primary" onClick={() => {
                        if (cameraFacingMode === 'user') {
                          setCameraFacingMode({
                            exact: 'environment'
                          })
                        } else {
                          setCameraFacingMode('user')
                        }
                      }}>Flip Camera</Button>
                    </div>

                  </Col>
                </Row>
                : <></>
            }
            {
              capturedImage && (
                <Row justify={"center"}>
                  <Col span={window.screen.width > 767 ? 12 : 24}>
                    <div className='uploaded-img' onClick={() => {
                      setOpenCamera(true);
                      setCapturedImage(false);
                    }}>
                      <div className="img">
                        <img
                          src={capturedImage}
                        />
                      </div>
                      <div className='img-delete-icon'>
                        <span>
                          <CameraOutlined className="img-trash" />
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <Button>Retake Picture</Button>
                  </Col>
                </Row>
              )
            }
            <div style={{ width: '100%', justifyContent: 'center', display: 'flex', marginTop: 20 }}>
              <Button loading={formLoading} htmlType="submit" type="primary">Submit</Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default CameraComponent;